/* eslint-disable no-underscore-dangle */


import Vue from 'vue';
import FastClick from 'fastclick';
import VueRouter from 'vue-router';
import 'babel-polyfill';
import VueLazyload from 'vue-lazyload';
import WechatPlugin from 'vux/src/plugins/wechat/index.js'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import App from './App';
import router from './router';
import AjaxPlugin from './common/request'
import "./assets/font/iconfont.css";


Vue.directive('transfer-dom', TransferDom)

const imgDefault = require("./assets/img/imgDefault.png")

Vue.use(WechatPlugin);
Vue.use(VueRouter);
Vue.use(AjaxPlugin);

Vue.use(VueLazyload, {
preLoad: 2,
error: imgDefault,
attempt: 1
});
FastClick.attach(document.body);

Vue.config.productionTip = false;

function formatComponentName(vm) {
if (vm.$root === vm) return 'root';
const name = vm._isVue
? (vm.$options && vm.$options.name) ||
(vm.$options && vm.$options._componentTag)
: vm.name;
return (
(name ? `component <${name}>` : 'anonymous component') +
(vm._isVue && vm.$options && vm.$options.__file
? ` at ${vm.$options && vm.$options.__file}`
: '')
);
}
Vue.config.errorHandler = (error, vm, info) => {
console.log('errorHandler:', error)
const params = {
msg: `${error}`,
extra_info: {
info: info || "-",
componentName: vm ? formatComponentName(vm) : '-'
}
};
if (window.lvyue_report_log) {
window.lvyue_report_log.postAjax(params, "componentDidCatch");
}
window.location.replace(
`https://m.lvyuetravel.com/inHotel/ErrorPage?redirect_uri=${window.location.href}`
);
}
/* eslint-disable no-new */
new Vue({
data: {
Bus: new Vue()
},
router,
render: h => h(App)
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js